export default function Link({ href, children }) {

	return (
		<a href={href} className="text-[#f7f8f8] hover:underline">{children}</a>
	)
}
